import type { SelectionState } from './mutations';

export default {
  selectedHomeId(state: SelectionState){
    return state.selectedHomeId;
  },
  selectedRoomId(state: SelectionState){
    return state.selectedRoomId;
  },
  selectedDeviceId(state: SelectionState){
    return state.selectedDeviceId;
  },
  selectedGatewayId(state: SelectionState){
    return state.selectedGatewayId;
  },

  photoUrlByHome(state: SelectionState){
    return state.photoUrlByHome;
  },
  roomsByHome(state: SelectionState){
    return state.roomsByHome;
  },
  getPhotoForHome: (state: SelectionState) => (homeUid: string) => {
    return state.photoUrlByHome[homeUid];
  },
  getRoomsForHome: (state: SelectionState) => (homeUid: string) => {
    return state.roomsByHome[homeUid];
  },
};


